import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Role } from '../api/types';
import config from '../config';

async function getAllRoles(axios: AxiosInstance): Promise<Role[]> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/roles`);

  return data;
}

export default function useAllRolesQuery() {
  const axios = useAxios();
  const toast = useToast();
  const navigate = useNavigate();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getAllRoles(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as any;
      if (error?.response?.status !== 503) {
        manageErrorResponse(toast, error);
      }
      if (error?.response?.status >= 500 && error?.response?.status !== 503) {
        navigate('/app/errorPage', { replace: true });
      }
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['Roles'] as const satisfies QueryKey;
}
useAllRolesQuery.getKey = getKey;
